import { render, staticRenderFns } from "./StaffPage.vue?vue&type=template&id=0cc1bf66&scoped=true"
import script from "./StaffPage.vue?vue&type=script&lang=js"
export * from "./StaffPage.vue?vue&type=script&lang=js"
import style0 from "./StaffPage.vue?vue&type=style&index=0&id=0cc1bf66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1bf66",
  null
  
)

export default component.exports